module.exports = __webpack_public_path__ + "static/young-leader-photo-blanca_ribas_pombo-54cae225785e9d86043a774c5c2d78f1.jpg";